import LightDarkImg from "discourse/components/light-dark-img";
import PluginOutlet from "discourse/components/plugin-outlet";
import lazyHash from "discourse/helpers/lazy-hash";

<template>
  <div
    class="circles__logo
      {{if @model.hasLogo '--has-image'}}
      {{unless @model.hasLogo '--blank'}}"
    ...attributes
  >
    <PluginOutlet @name="circles-logo" @outletArgs={{lazyHash model=@model}}>
      {{#if @model.hasLogo}}
        <LightDarkImg
          @lightImg={{@model.category.uploaded_logo}}
          @darkImg={{@model.category.uploaded_logo_dark}}
        />
      {{/if}}
    </PluginOutlet>
  </div>
</template>
